import React, { ReactNode, memo } from 'react'
import { Button } from 'transfix-ui/components/Button'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { DISPLAY } from 'constants/display'
import { useSidebarCardRowStyles } from './useSidebarCardRowStyles'

export interface ICarrierProfileCardRowProps {
  title: string
  value: ReactNode
  onEdit: () => void
}

const SidebarCardRow = memo<ICarrierProfileCardRowProps>(({ onEdit, title, value }) => {
  const classes = useSidebarCardRowStyles()
  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      justifyContent='flex-start'
      className={classes.row}>
      <div className={classes.details}>
        <Box flex={1} className={classes.item}>
          <Typography color='textSecondary' variant='caption'>
            {title}
          </Typography>
        </Box>
        <Box flex={2} className={classes.item}>
          {!!value && <>{value}</>}
          {!value && <Typography variant='body2'>{DISPLAY.emptyDash}</Typography>}
        </Box>
      </div>
      <Box flex={0.5} className={classes.buttonWrapper}>
        <Button variant='text' onClick={onEdit}>
          {!value ? 'Add' : 'Update'}
        </Button>
      </Box>
    </Box>
  )
})

export default SidebarCardRow
